// components
import maPaginator from '@/components/paginator'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maInputSelectUsers from '@/components/input/modules/selectUsers'
import maEmpty from '@/components/empty'

// vuex
import { mapState } from 'vuex'

// types
import { USER_MODULE_NAME } from '@/store/types'

// api
import {
  apiGetAdminUserCompanies,
  apiGetAdminUserRoles,
  apiGetAdminUserList,
  apiPostAdminUser,
  apiPatchAdminUser,
  apiPostAdminUserDelete
} from '@/services/API/admin'

export default {
  name: 'adminUsers',
  data: function () {
    return {
      modalUser: {
        username: null,
        firstName: null,
        lastName: null,
        company: null,
        email: null,
        role: null
      },
      companyOptions: [],
      roleOptions: [],
      userTable: [],
      companyFilter: null,
      currentPage: 1,
      totalPages: 0,

      userToDelete: null
    }
  },
  components: {
    maModal,
    maInputText,
    maInputSelect,
    maPaginator,
    maEmpty,
    maInputSelectUsers
  },
  computed: {
    ...mapState(USER_MODULE_NAME, {
      stateUserRole: 'role'
    }),
    hasData: function () {
      return this.userTable && this.userTable.length > 0
    }
  },
  methods: {
    handleCompanyFilterChange (company) {
      this.companyFilter = company
      this.currentPage = 1
      this.handleSearch()
    },
    handlePageUpdate: function (page) {
      this.currentPage = page
      this.handleSearch()
    },
    handlePageSet: function (page) {
      this.currentPage = page
    },
    handleSearch: function () {
      this.getUserList(this.companyFilter, this.currentPage)
    },
    closeModalAndRefreshForm: function (ref) {
      this.$refs[ref].showModal = false
      this.modalUser = {
        username: null,
        firstName: null,
        lastName: null,
        company: null,
        email: null,
        role: null,
        password: null,
        repeatPassword: null
      }
      this.roleOptions = []
      this.userToDelete = null
    },
    handleNewUserButtonClick: function () {
      this.$refs.userModal.showModal = true
    },
    resetModalUser: function () {
      Object.keys(this.modalUser).forEach(k => { this.modalUser[k] = null })
      this.roleOptions = []
    },
    handleNewUserSave: function () {
      if (this.validateNewUser()) {
        apiPostAdminUser(
          this.modalUser.firstName,
          this.modalUser.lastName,
          this.modalUser.username,
          this.modalUser.email,
          this.modalUser.company,
          this.modalUser.role
        )
          .then((data) => {
            this.getUserList(this.companyFilter, this.currentPage)
            this.closeModalAndRefreshForm('userModal')
            this.throwNotification(this.$t(`notifications.user.createdUser.title`), this.$t(`notifications.user.createdUser.body`), 'OK')
          })
          .catch((err) => {
            const errs = [400, 500, 409]
            const errCode = errs.find(errCode => err.response.status === errCode) || 0
            this.throwNotification(this.$t(`notifications.user.error.${errCode}.title`), this.$t(`notifications.user.error.${errCode}.body`), 'KO')
          })
      }
    },
    handleEditUserButtonClick: function (firstName, lastName, username, email, company, role) {
      this.modalUser.firstName = firstName
      this.modalUser.lastName = lastName
      this.modalUser.username = username
      this.modalUser.email = email
      this.modalUser.company = company
      this.modalUser.role = role
      //
      this.$refs.editModal.showModal = true
      //
      this.getUserRoles(company)
    },
    handleEditUserSave: function () {
      if (this.validateEditUser()) {
        apiPatchAdminUser(
          this.modalUser.firstName,
          this.modalUser.lastName,
          this.modalUser.username,
          this.modalUser.email,
          this.modalUser.company,
          this.modalUser.role
        )
          .then((data) => {
            this.getUserList(this.companyFilter, this.currentPage)
            this.closeModalAndRefreshForm('editModal')
            this.throwNotification(this.$t(`notifications.user.modifiedUser.title`), this.$t(`notifications.user.modifiedUser.body`), 'OK')
          })
          .catch((err) => {
            const errs = [400, 500, 409]
            const errCode = errs.find(errCode => err.response.status === errCode) || 0
            this.throwNotification(this.$t(`notifications.user.error.${errCode}.title`), this.$t(`notifications.user.error.${errCode}.body`), 'KO')
          })
      }
    },

    validateRequired: function (target, excludedFields = []) {
      let err = false
      const nonExcludedFields = Object.keys(target).filter(t => {
        return (excludedFields.indexOf(t) === -1)
      })
      for (let f of nonExcludedFields) {
        const targetField = target[f]
        if (!targetField || targetField.length <= 0) {
          this.throwNotification(this.$t('notifications.user.isRequired.title'), this.$t('notifications.user.isRequired.body'), 'KO')
          err = true
          break
        }
      }
      return !err
    },

    validateEmail: function (email) {
      if (email && email.length > 0) {
        const testEmail = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email)
        if (!testEmail) {
          this.throwNotification(this.$t('notifications.user.isEmail.title'), this.$t('notifications.user.isEmail.body'), 'KO')
          return false
        }
      }
      return true
    },

    validatePassword: function (password, repeatPassword) {
      if (password !== repeatPassword) {
        this.throwNotification(this.$t('notifications.user.isSamePassword.title'), this.$t('notifications.user.isSamePassword.body'), 'KO')
        return false
      }
      return true
    },

    validateNewUser: function () {
      // all except password are required
      if (!this.validateRequired(this.modalUser)) return
      // email validation
      if (!this.validateEmail(this.modalUser.email)) return
      return true
    },

    validateEditUser: function () {
      // all except password are required
      if (!this.validateRequired(this.modalUser, ['password', 'repeatPassword'])) return
      // email validation
      if (!this.validateEmail(this.modalUser.email)) return
      return true
    },

    handleUserCancel: function () {
      this.$refs.userModal.closeModal()
    },
    handleDeleteUserButtonClick: function (username) {
      this.userToDelete = username
      this.$refs.deleteModal.showModal = true
    },
    handleDelete: function () {
      apiPostAdminUserDelete(this.userToDelete)
        .then(() => {
          this.handleSearch()
          this.closeModalAndRefreshForm('deleteModal')
          this.throwNotification(this.$t(`notifications.user.deletedUser.title`), this.$t(`notifications.user.deletedUser.body`), 'OK')
        })
        .catch((err) => {
          const errs = [400, 500, 409]
          const errCode = errs.find(errCode => err.response.status === errCode) || 0
          this.throwNotification(this.$t(`notifications.error.${errCode}.title`), this.$t(`notifications.error.${errCode}.body`), 'KO')
        })
    },
    handleChangeCompany: function (companyId) {
      this.modalUser.company = companyId
      this.getUserRoles(companyId)
    },
    getUserCompanies: function () {
      apiGetAdminUserCompanies()
        .then((data) => {
          this.companyOptions = data
        })
        .catch((err) => {
          const errs = [400, 500, 409]
          const errCode = errs.find(errCode => err.response.status === errCode) || 0
          this.throwNotification(this.$t(`notifications.error.${errCode}.title`), this.$t(`notifications.error.${errCode}.body`), 'KO')
        })
    },
    getUserRoles: function (companyId) {
      apiGetAdminUserRoles(companyId)
        .then((data) => {
          this.roleOptions = data
        })
        .catch((err) => {
          const errs = [400, 500, 409]
          const errCode = errs.find(errCode => err.response.status === errCode) || 0
          this.throwNotification(this.$t(`notifications.error.${errCode}.title`), this.$t(`notifications.error.${errCode}.body`), 'KO')
        })
    },
    getUserList: function (companyId, page) {
      apiGetAdminUserList(companyId, page)
        .then((data) => {
          this.userTable = data.results
          this.totalPages = data.total_pages
        })
        .catch((err) => {
          const errs = [400, 500, 409]
          const errCode = errs.find(errCode => err.response.status === errCode) || 0
          this.throwNotification(this.$t(`notifications.error.${errCode}.title`), this.$t(`notifications.error.${errCode}.body`), 'KO')
        })
    }
  },
  mounted: function () {
    this.getUserCompanies()
    this.getUserList()
  },
  watch: {
    companyFilter: function () {
      this.getUserList(this.companyFilter)
    }
  }
}
